import { render } from "./ScoutTab.vue?vue&type=template&id=2f2e97e6&scoped=true"
import script from "./ScoutTab.vue?vue&type=script&lang=js"
export * from "./ScoutTab.vue?vue&type=script&lang=js"

import "./ScoutTab.vue?vue&type=style&index=0&id=2f2e97e6&scoped=true&lang=scss"

import exportComponent from "/home/misha/Рабочий стол/sportkit-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f2e97e6"]])

export default __exports__